module.exports = __webpack_public_path__ + "img/roulette-card-clubs.be2b9657.svg";